import * as React from 'react';
import { FC } from 'react';
import Currencies from './Currencies';
import BankNames from './BankNames';
import Amount from './Amount';
import { useContext, FormContext } from './useFormContext';

const BonusCode: FC<{ context: FormContext }> = ({ context }) => (
  <div className="rs-column-small-12">
    <label htmlFor="bonus_code">{`${context.locales.bonus_code_label}:`}</label>
    <input name="bonus_code" type="text" autoComplete="off" />
  </div>
);

const MainFields: FC<{
  currency: string;
  changeCurrency: (v: string) => void;
  amount: string;
  changeAmount: (v: string) => void;
  amountCurrency: string;
  hasAmountError: boolean;
}> = ({ currency, changeCurrency, amount, changeAmount, amountCurrency, hasAmountError }) => {
  const context = useContext();

  if (context.isDeposit)
    return (
      <div>
        <Currencies value={currency} onChange={changeCurrency} />
        {context.key === 'InitialCardDeposit' && <BankNames context={context} currency={currency} />}
        <Amount value={amount} onChange={changeAmount} currency={amountCurrency} error={hasAmountError} />
        <BonusCode context={context} />
      </div>
    );

  return (
    <div>
      <Amount value={amount} onChange={changeAmount} currency={amountCurrency} error={hasAmountError} />
      <Currencies value={currency} onChange={changeCurrency} />
    </div>
  );
};

export default MainFields;
